export default __webpack_public_path__ + "static/spezia-monospace-semi-mono-medium-8de0308679e5571d7a91dbfb1780873a.woff";